<template>
  <div class="pre-paid">
    预付款活动账单，不参与付款
  </div>
</template>

<script>
export default {
  name: 'PrePaidTip',
};
</script>

<style lang="scss" scoped>
.pre-paid {
  text-align: left;
  color: red;
}
</style>
